<template>
    <div>
        <div class="popup__header--tariffs">
            <span class="title title--sm popup__title">{{ $lang('addPage.title') }}</span>
        </div>
        <p class="create__text">Выберите тип страницы — краткая (бесплатная) или расширенная <br> (с большим количеством функций)</p>
        <swiper
            @sliderMove="closePopovers"
            class="tariffs__create-swiper"
            :options="swiperOptions"
        >
            <swiper-slide
                class="tariffs__block"
                :class="{ 'tariffs__block--active': tariff.active }"
                v-for="(tariff, index) in tariffs"
                :key="index"
                v-if="isVisible(tariff, index)"
            >
                <div class="tariffs__active-msg" v-if="tariff.active">
                    {{ $lang("tariffs.optimal") }}
                </div>

                <div class="tariffs__header">
                    <h2
                        class="title title--uppercase title--xs tariffs__item-title"
                    >
                        {{ tariff.name }}
                    </h2>

                    <a
                        v-if="tariff.example"
                        class="link link--small tariffs__example-link"
                        :href="tariff.example"
                    >
                        <span>{{ $lang("tariffs.col1.example") }}</span>
                    </a>
                </div>



                <div class="tariffs__content">
                    <div class="tariffs__options">
                        <svg
                            v-if="tariff.options.icon"
                            :width="tariff.options.width"
                            :height="tariff.options.height"
                        >
                            <use
                                :xlink:href="
                                        '/assets/front/img/sprite.svg#icon-' +
                                            tariff.options.icon
                                    "
                            ></use>
                        </svg>

                        <p
                            class="tariffs__options-text"
                            :class="{
                                    'tariffs__options-text--with-icons':
                                        tariff.options.icon
                                }"
                        >
                            {{ tariff.options.text }}
                        </p>
                    </div>

                    <ul class="tariffs__a-options">
                        <li
                            class="tariffs__a-options-item"
                            v-for="option in tariff.additionalOptions"
                        >
                            <svg
                                class="tariffs__a-options-icon"
                                width="25"
                                height="25"
                            >
                                <use
                                    :xlink:href="
                                            '/assets/front/img/sprite.svg#icon-' +
                                                option.icon
                                        "
                                ></use>
                            </svg>

                            <div>
                                    <span class="tariffs__a-options-name">{{
                                            option.name
                                        }}</span>

                                <el-popover
                                    class="tariffs__popover"
                                    placement="bottom"
                                    ref="popovers"
                                    v-if="option.popover"
                                    width="290"
                                    trigger="hover"
                                    :content="option.popover"
                                >
                                    <img
                                        class="tariffs__popover--icon"
                                        slot="reference"
                                        src="/assets/front/img/popover.svg"
                                        alt="#"
                                    />
                                </el-popover>

                                <p
                                    v-if="option.desc"
                                    class="tariffs__a-options-desc"
                                >
                                    {{ option.desc }}
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="tariffs__bottom">
                    <div class="title title--bold title--sl tariffs__price">
                        <span>{{ tariff.price }}</span>

                        <span>{{ currency }}</span>
                    </div>

                    <a
                        class="btn btn--main-bg btn--middle tariffs__btn"
                        @click.stop="redirect(tariff)"
                    >
                        {{ buttonName(index) }}
                    </a>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import Vue from "vue";
    import {mapGetters, mapMutations} from "vuex";
    import ApiService from "../../api/api";

    export default {
        name: "free",
        data() {
            return {
                isSubsrTariffs: false,
                currency: window.laravel.prices.currency.symbol,
                swiperOptions: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                    breakpoints: {
                        300: {
                            slidesPerView: 1,
                            spaceBetween: 15
                        },
                        550: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                    }
                },
                tariffs: [
                    {
                        name: Vue.prototype.$lang("tariffs.col1.name"),
                        example: window.laravel.pagesExamples.short,
                        price: parseInt(window.laravel.prices.short.price),
                        route: "free",
                        options: {
                            width: null,
                            height: null,
                            icon: null,
                            text: Vue.prototype.$lang("tariffs.options")
                        },
                        additionalOptions: [
                            {
                                icon: "tariffs_epitaph",
                                name: Vue.prototype.$lang("tariffs.row1")
                            },
                            {
                                icon: "tariffs_map",
                                name: Vue.prototype.$lang("tariffs.row2")
                            },
                            {
                                icon: "tariffs_relations",
                                name: Vue.prototype.$lang("tariffs.row3")
                            },
                            {
                                icon: "tariffs_qr",
                                name: Vue.prototype.$lang("tariffs.row4")
                            },
                            {
                                icon: "tariffs_private",
                                name: Vue.prototype.$lang("tariffs.row5"),
                                popover: Vue.prototype.$lang("tariffs.row6")
                            }
                        ],
                        active: false,
                        paymentType: null,
                        copyright: false
                    },
                    {
                        name: Vue.prototype.$lang("tariffs.col2.name"),
                        example: window.laravel.pagesExamples.full,
                        price: parseInt(window.laravel.prices.full.price),
                        route: "pay",
                        options: {
                            width: 99,
                            height: 27,
                            icon: "tariffs_all_short",
                            text: Vue.prototype.$lang("tariffs.col2.allInShort")
                        },
                        additionalOptions: [
                            {
                                icon: "tariffs_biography",
                                name: Vue.prototype.$lang("tariffs.row7")
                            },
                            {
                                icon: "tariffs_photo",
                                name: Vue.prototype.$lang("tariffs.row8")
                            },
                            {
                                icon: "tariffs_video",
                                name: Vue.prototype.$lang("tariffs.row9")
                            },
                            {
                                icon: "tariffs_reviews",
                                name: Vue.prototype.$lang("tariffs.row10")
                            },
                            {
                                icon: "tariffs_qr_table",
                                name: Vue.prototype.$lang("tariffs.row11"),
                                popover: Vue.prototype.$lang("tariffs.row12")
                            }
                        ],
                        active: true,
                        paymentType: window.laravel.paymentTypes.page,
                        copyright: false
                    },
                ],
                isMaster: window.laravel.isMaster,
                isPartner: window.laravel.isPartner,
                promoCode: null
            };
        },
        mounted() {
            if (window.laravel.promoCode) {
                this.getPromoCode();
            }
        },
        computed: {
            ...mapGetters('subscribe',{
                isTabTree: 'isTabTree'
            }),
        },
        methods: {
            ...mapMutations('subscribe', [
                'setSwitchTab',
            ]),
            change(event){
                this.setSwitchTab(event);
            },
            isVisible(tariff, index) {
                return !(index !== 0 && tariff.price === 0);
            },
            closePopovers(swiper, event) {
                this.$refs.popovers.forEach(item => item.doClose());
            },
            buttonName(index) {
                return index === 0 || this.isPartner
                    ? Vue.prototype.$lang("tariffs.button.create")
                    : Vue.prototype.$lang("tariffs.button.pay");
            },
            redirect(tariff) {
                if (this.isPartner) {
                    location.href = window.laravel.prefix + "/cabinet/pages";
                } else if (this.isMaster) {
                    location.href = window.laravel.prefix + "/cabinet/pages";
                } else {
                    this.$router.push({
                        name: tariff.route,
                        params: {
                            price: tariff.price,
                            paymentType: tariff.paymentType,
                            copyright: tariff.copyright
                        }
                    });
                }
            },
        }
    }
</script>

<style>

</style>
